export class AuthorizationCode {
    authCode = "";
}
